import { FC } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/AddOutlined";
import __ from "src/utils/Translations";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import { absencesAbsencesConfigurationWrite } from "src/utils/RoleBasedSecurity/permissions";

const AbsenceGroupsEmpty: FC = () => {
  const match = useRouteMatch();
  const canWriteAbsencesConfiguration = usePermission(
    absencesAbsencesConfigurationWrite
  );

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "2rem",
      }}
      data-testid="absence-groups-empty"
    >
      <Typography variant="h5" component="h2">
        {__("Brak grup do wyświetlenia")}
      </Typography>
      <Typography variant="body1" sx={{ margin: "2rem 0" }}>
        {__(
          "Najpierw stwórz grupy nieobecności, a potem przypisz do nich wybrane wnioski o nieobecność."
        )}
        <br />
        {__(
          "Powiązanie wniosku z grupą jest wymagane podczas jego konfiguracji."
        )}
      </Typography>
      {canWriteAbsencesConfiguration && (
        <Button
          component={Link}
          variant="contained"
          to={`${match.url}/new`}
          startIcon={<AddIcon />}
        >
          {__("Nowa grupa")}
        </Button>
      )}
    </Box>
  );
};

export default AbsenceGroupsEmpty;
